import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

export const getPopupContentStyle = (isMobile: boolean) => ({
  width: isMobile ? '100%' : 'auto',
  height: isMobile ? '100%' : 'auto',
  padding: isMobile ? '1.25rem 1.25rem 1.375rem' : '1.5rem 1.875rem 1.375rem',
});

export const ActionBtnStyled = styled(Button)`
  height: 48px;
  flex: 1 1;
  font-size: ${({ theme }) => theme.fontSize['2xl']};
  &:first-child {
    margin-right: 1rem;
  }
  ${({ theme }) => `
    ${theme.devices.tablet} {    
      width: 140px;
      height: 38px;
      flex: none;
      font-size: ${theme.fontSize.lg};
    }
  `}
`;

export const FlexContainerMessageStyled = styled(FlexContainer)`
  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding: 0 2.5rem 0.625rem;
    }
  `}
`;

export const VersionStyled = styled(Typography)`
  margin-left: 0.625rem;
  padding: 0.25rem;
  background-color: ${({ theme }) => theme.colors.primary.variant3};
  border-radius: ${({ theme }) => theme.radius.sm};
`;

export const CategoryTitleStyled = styled(Typography)`
  margin-top: 1rem;
`;

export const NotesListStyled = styled.ul`
  list-style: disc;
  margin-left: 1.25rem;
`;

export const ListItemStyled = styled.li`
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  margin: 0.5rem 0.5rem 0.5rem 0.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radius.lg};
`;

export const TypographyStyled = styled(Typography)`
  word-break: break-word;
`;
